import { HiddenDataWrapper } from "helpers/hiddenData";
import React from "react";

const Markup = ({ renderField, renderCheckbox, Button, renderSelect, renderFuelCards, renderDeviceInfo, ...props }) => {
    const {
        firstName,
        lastName,
        patronymic,
        phoneNumber,
        snils,
        inn,
        comment,
        needsShiftChangeComment,
        needsUrgentShiftChange,
        transportColumnId,
        accessPermitIds,
    } = props;
    return (
        <>
            {renderField(lastName)}
            {renderField(firstName)}
            {renderField(patronymic)}
            <HiddenDataWrapper>{renderField({ ...phoneNumber, type: "phone" })}</HiddenDataWrapper>
            <HiddenDataWrapper>{renderField(snils)}</HiddenDataWrapper>
            <HiddenDataWrapper>{renderField(inn)}</HiddenDataWrapper>
            {renderSelect(transportColumnId)}
            {renderField(comment)}
            {renderField(needsShiftChangeComment)}
            {renderCheckbox(needsUrgentShiftChange)}
            {renderSelect(accessPermitIds)}
            {renderFuelCards()}
            {renderDeviceInfo()}
            {!!Button && <Button />}
        </>
    );
};

export default Markup;
